var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 72,
    viewBox: "0 0 250 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.741 71.9375H9.25926C4.16898 71.9375 0 67.9148 0 63.0032V9.39765C0 4.48604 4.16898 0.463384 9.25926 0.463384H240.741C245.831 0.463384 250 4.48604 250 9.39765V63.0032C250 67.9148 245.831 71.9375 240.741 71.9375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.741 1.8951C245.028 1.8951 248.516 5.26108 248.516 9.39765V63.0032C248.516 67.1398 245.028 70.5058 240.741 70.5058H9.25926C4.97222 70.5058 1.4838 67.1398 1.4838 63.0032V9.39765C1.4838 5.26108 4.97222 1.8951 9.25926 1.8951H240.741ZM240.741 0.463384H9.25926C4.16898 0.463384 0 4.48604 0 9.39765V63.0032C0 67.9148 4.16898 71.9375 9.25926 71.9375H240.741C245.831 71.9375 250 67.9148 250 63.0032V9.39765C250 4.48604 245.831 0.463384 240.741 0.463384Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8096 18.7678C87.8096 20.2599 87.3467 21.4548 86.4346 22.346C85.386 23.4025 84.0203 23.9341 82.3467 23.9341C80.7471 23.9341 79.3814 23.3936 78.261 22.3281C77.1383 21.2471 76.5781 19.9203 76.5781 18.3323C76.5781 16.7442 77.1383 15.4175 78.261 14.3453C79.3814 13.271 80.7471 12.7305 82.3467 12.7305C83.143 12.7305 83.9022 12.8891 84.6268 13.1839C85.349 13.481 85.9369 13.883 86.3629 14.3788L85.3953 15.3214C84.6522 14.4749 83.6406 14.0572 82.3467 14.0572C81.18 14.0572 80.1684 14.4503 79.3096 15.2432C78.4601 16.0384 78.0341 17.0681 78.0341 18.3323C78.0341 19.5965 78.4601 20.6351 79.3096 21.4302C80.1684 22.2142 81.18 22.6163 82.3467 22.6163C83.5851 22.6163 84.6268 22.2142 85.4485 21.4213C85.9902 20.8964 86.2981 20.1727 86.3791 19.248H82.3467V17.957H87.7263C87.7911 18.2362 87.8096 18.5065 87.8096 18.7678Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3452 14.2921H91.2919V17.6871H95.8475V18.9781H91.2919V22.3732H96.3452V23.6887H89.8613V12.9766H96.3452V14.2921Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.368 23.6887H100.937V14.2921H97.8379V12.9766H105.47V14.2921H102.368V23.6887Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.992 23.6887V12.9766H112.42V23.6887H110.992Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.753 23.6887H117.334V14.2921H114.223V12.9766H121.864V14.2921H118.753V23.6887Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.312 22.3103C135.217 23.3936 133.861 23.9341 132.243 23.9341C130.615 23.9341 129.259 23.3936 128.164 22.3103C127.071 21.2292 126.527 19.9025 126.527 18.3323C126.527 16.7621 127.071 15.4353 128.164 14.3543C129.259 13.271 130.615 12.7305 132.243 12.7305C133.851 12.7305 135.208 13.271 136.303 14.3632C137.405 15.4532 137.949 16.771 137.949 18.3323C137.949 19.9025 137.405 21.2292 136.312 22.3103ZM129.222 21.4124C130.046 22.2142 131.048 22.6163 132.243 22.6163C133.428 22.6163 134.439 22.2142 135.254 21.4124C136.076 20.6105 136.493 19.5808 136.493 18.3323C136.493 17.0837 136.076 16.054 135.254 15.2522C134.439 14.4503 133.428 14.0483 132.243 14.0483C131.048 14.0483 130.046 14.4503 129.222 15.2522C128.4 16.054 127.983 17.0837 127.983 18.3323C127.983 19.5808 128.4 20.6105 129.222 21.4124Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.956 23.6887V12.9766H141.692L147.09 21.3077H147.153L147.09 19.2484V12.9766H148.519V23.6887H147.028L141.375 14.9466H141.313L141.375 17.0148V23.6887H139.956Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.176 39.3325C121.826 39.3325 118.273 42.5265 118.273 46.9333C118.273 51.3044 121.826 54.5319 126.176 54.5319C130.535 54.5319 134.088 51.3044 134.088 46.9333C134.088 42.5265 130.535 39.3325 126.176 39.3325ZM126.176 51.5389C123.789 51.5389 121.736 49.6382 121.736 46.9333C121.736 44.1927 123.789 42.3255 126.176 42.3255C128.562 42.3255 130.625 44.1927 130.625 46.9333C130.625 49.6382 128.562 51.5389 126.176 51.5389ZM108.933 39.3325C104.574 39.3325 101.03 42.5265 101.03 46.9333C101.03 51.3044 104.574 54.5319 108.933 54.5319C113.289 54.5319 116.836 51.3044 116.836 46.9333C116.836 42.5265 113.289 39.3325 108.933 39.3325ZM108.933 51.5389C106.544 51.5389 104.484 49.6382 104.484 46.9333C104.484 44.1927 106.544 42.3255 108.933 42.3255C111.319 42.3255 113.373 44.1927 113.373 46.9333C113.373 49.6382 111.319 51.5389 108.933 51.5389ZM88.4143 41.6621V44.8918H96.4074C96.1736 46.6966 95.5486 48.0233 94.5903 48.948C93.4236 50.0648 91.6065 51.3044 88.4143 51.3044C83.4954 51.3044 79.6435 47.4738 79.6435 42.7275C79.6435 37.9812 83.4954 34.1506 88.4143 34.1506C91.0741 34.1506 93.0093 35.1535 94.4375 36.4534L96.7963 34.1774C94.7986 32.3369 92.1412 30.9231 88.4143 30.9231C81.669 30.9231 76 36.2189 76 42.7275C76 49.2361 81.669 54.5319 88.4143 54.5319C92.0602 54.5319 94.7986 53.3794 96.9514 51.2173C99.1574 49.0887 99.8449 46.0957 99.8449 43.679C99.8449 42.9285 99.7801 42.2384 99.6643 41.6621H88.4143ZM172.317 44.1659C171.667 42.4662 169.66 39.3325 165.572 39.3325C161.521 39.3325 158.148 42.4126 158.148 46.9333C158.148 51.1905 161.486 54.5319 165.961 54.5319C169.579 54.5319 171.667 52.4033 172.525 51.1637L169.84 49.4371C168.944 50.7013 167.725 51.5389 165.961 51.5389C164.208 51.5389 162.951 50.7639 162.146 49.2361L172.681 45.0303L172.317 44.1659ZM161.576 46.6966C161.486 43.7661 163.935 42.2652 165.69 42.2652C167.065 42.2652 168.231 42.9285 168.62 43.8778L161.576 46.6966ZM153.014 54.0696H156.477V31.7339H153.014V54.0696ZM147.343 41.0255H147.227C146.449 40.1366 144.965 39.3325 143.086 39.3325C139.141 39.3325 135.535 42.6739 135.535 46.9579C135.535 51.2173 139.141 54.5319 143.086 54.5319C144.965 54.5319 146.449 53.7211 147.227 52.8054H147.343V53.8954C147.343 56.8012 145.734 58.3625 143.139 58.3625C141.023 58.3625 139.711 56.8883 139.169 55.6487L136.157 56.8615C137.025 58.8762 139.324 61.3555 143.139 61.3555C147.199 61.3555 150.625 59.0504 150.625 53.4419V39.7948H147.343V41.0255ZM143.382 51.5389C140.995 51.5389 138.998 49.6114 138.998 46.9579C138.998 44.2798 140.995 42.3255 143.382 42.3255C145.734 42.3255 147.588 44.2798 147.588 46.9579C147.588 49.6114 145.734 51.5389 143.382 51.5389ZM188.53 31.7339H180.248V54.0696H183.701V45.6066H188.53C192.366 45.6066 196.127 42.9285 196.127 38.6691C196.127 34.4119 192.356 31.7339 188.53 31.7339ZM188.62 42.4997H183.701V34.8408H188.62C191.199 34.8408 192.671 36.9068 192.671 38.6691C192.671 40.3979 191.199 42.4997 188.62 42.4997ZM209.97 39.29C207.474 39.29 204.88 40.3532 203.812 42.7096L206.877 43.9493C207.537 42.7096 208.75 42.3076 210.032 42.3076C211.824 42.3076 213.641 43.3462 213.669 45.18V45.4145C213.044 45.0661 211.706 44.5501 210.06 44.5501C206.759 44.5501 203.396 46.3035 203.396 49.5756C203.396 52.5686 206.099 54.4962 209.139 54.4962C211.463 54.4962 212.745 53.4844 213.551 52.3073H213.669V54.0338H217.005V45.4659C217.005 41.5057 213.94 39.29 209.97 39.29ZM209.553 51.53C208.424 51.53 206.849 50.9895 206.849 49.6382C206.849 47.9094 208.812 47.246 210.512 47.246C212.032 47.246 212.745 47.5699 213.669 47.9965C213.398 50.0648 211.553 51.53 209.553 51.53ZM229.157 39.7792L225.187 49.4617H225.069L220.965 39.7792H217.241L223.407 53.3102L219.889 60.8395H223.498L233 39.7792H229.157ZM198.025 54.0696H201.488V31.7339H198.025V54.0696Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3236 13.9352C18.7797 14.4847 18.4648 15.3401 18.4648 16.448V55.9643C18.4648 57.0721 18.7797 57.9276 19.3236 58.477L19.4579 58.5977L42.407 36.463V35.9403L19.4579 13.8057L19.3236 13.9352Z",
    fill: "url(#paint0_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0485 43.8438L42.4072 36.4619V35.9392L50.0577 28.5574L50.229 28.6534L59.2892 33.6275C61.8749 35.0391 61.8749 37.362 59.2892 38.7825L50.229 43.7477L50.0485 43.8438Z",
    fill: "url(#paint1_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2293 43.7472L42.4076 36.2L19.3242 58.4754C20.183 59.3465 21.5835 59.4515 23.1761 58.5804L50.2293 43.7472Z",
    fill: "url(#paint2_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2293 28.652L23.1761 13.819C21.5835 12.9568 20.183 13.0618 19.3242 13.9329L42.4076 36.1992L50.2293 28.652Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.3694,
    y1: 56.3758,
    x2: 10.4008,
    y2: 25.3171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 62.6562,
    y1: 36.1981,
    x2: 17.847,
    y2: 36.1981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 45.9761,
    y1: 32.0971,
    x2: 5.33607,
    y2: -10.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 13.5137,
    y1: 71.6213,
    x2: 31.6611,
    y2: 52.8138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.fd4ffe9a.svg";
export { ForwardRef as ReactComponent };